/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ComplianceRecommendation {
  RECOMMENDED = 'RECOMMENDED',
  NOT_RECOMMENDED = 'NOT_RECOMMENDED',
}
